import {
  ALL_COMPANY_ROW,
  MATCH_FILTER_KEYS,
  SORT_ORDER,
  SORT_TYPES,
} from "../utils/constant";

function getFavorite(key) {
  return (localStorage.getItem(key) || "")
    .split(",")
    .map((_id) => Number(_id, 10));
}

export default {
  sort: {
    type: SORT_TYPES.TIME,
    order: SORT_ORDER.DESC,
  },
  filters: [
    MATCH_FILTER_KEYS.ALL,
    { type: MATCH_FILTER_KEYS.COMPANY, value: ALL_COMPANY_ROW._id },
    { type: MATCH_FILTER_KEYS.SIGNAL_TYPES, value: new Set() },
  ],
  list: [],
  liveExpanded: [],
  tickerExpanded: [],
  prematchExpanded: [],
  // Единый серверный список избранного (BetsAPI matchId). Гостю — фолбэк из localStorage.
  favorites: getFavorite("favorites"),
  searchText: "",
};
